import { LockSimpleIcon } from '@phosphor-icons/react';

/** Pill that marks a value as not editable (lock glyph + "Read-only"). */
export function ReadOnlyTag() {
  return (
    <span className="inline-flex shrink-0 items-center gap-1.25 rounded-xs bg-surface-3 px-2 py-0.75 text-2xs font-medium leading-3.5 text-fg-tertiary">
      <LockSimpleIcon size={12} weight="bold" />
      Read-only
    </span>
  );
}
